import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { safeLocalStorage } from 'legacyfrontend/helpers/ssr-helper';

export function CookiesMessage() {
  const { t } = useTranslation(['layout']);
  const [isAccepted, setIsAccepted] = useState(true);

  useEffect(() => {
    const cookiesValue = safeLocalStorage.getItem('cookies');
    if (cookiesValue) {
      setIsAccepted(cookiesValue);
    } else {
      setIsAccepted(false);
    }
  }, []);

  function allowCookies() {
    safeLocalStorage.setItem('cookies', 'true');
    setIsAccepted(true);
  }

  return (
    <div>
      {!isAccepted && (
        <div className=' cookie fixed bottom-0 w-full'>
          <div className='lg:grid grid-cols-4   gap-8 py-8 md:container md:mx-auto'>
            <div className='text-cookies col-span-3  px-5 py-5 '>{t('footer.cookies')}</div>
            <div className=' px-5 py-5'>
              <button className='button-cookies' onClick={() => allowCookies()} type='button'>
                {t('footer.buttonAgree')}
              </button>
            </div>
          </div>
        </div>
      )}
      {isAccepted && <div />}
    </div>
  );
}
